import makeStyles from '@mui/styles/makeStyles';
import {ButtonBase, ButtonProps} from '@mui/material';
import cs from "classnames";
import React, {FunctionComponent, HTMLProps} from "react";


interface ChallengeButtonProps extends ButtonProps {
    title?: string,
    fw?: boolean,
    primary?: boolean,
    secondary?: boolean,
    protocolBanner? : boolean
}


const ChallengeButton: FunctionComponent<ChallengeButtonProps> = ({
                                                                    className, 
                                                                    fw, 
                                                                    primary,
                                                                    secondary,
                                                                    children,
                                                                    protocolBanner
                                                                }) => {
    const classes = useStyles()
    return (
        <ButtonBase className={cs(classes.root, className, 
        {[classes.fullwidth]: fw},
        {[classes.primary]: primary},
        {[classes.secondary]: secondary},
        {[classes.protocolBanner]: protocolBanner},
         )}
         >
            {children}
        </ButtonBase>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: '5rem',
        fontSize: '1rem',
        minHeight: '2.5rem',
        textAlign: 'start',
    },
    fullwidth: {
        width: '100%',
    },
    primary: {
        border: `3px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main
    },
    secondary: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText
    },
    protocolBanner: {
        backgroundColor: theme.palette.primary.contrastText,
        padding: '0.7rem',
        border: `1px solid ${theme.palette.secondary.main}`,
        boderRadius: 4,
        color: theme.palette.secondary.main,
        fontWeight: 500,
    }
}));

export default ChallengeButton